import React from "react";
const NotFound = () => {
  return (
    <>
      <div className="error">
        <div className="error-icon"></div>
        <div className="error-text">
          {/* <h3 className="error-heading">Something went wrong</h3> */}
          <h3 className="error-heading">Not Found</h3>
          {/* <div className="error-description">
            Sorry, this page is not available at the moment.
          </div> */}
        </div>
      </div>
    </>
  );
};

export { NotFound };
